<template>
  <form @submit.prevent="submitForm">
    <!-- Información Básica -->
    <div class="row">
      <div class="col-md-6">
        <FormField
          id="Clave"
          label="Clave"
          type="text"
          v-model="formData.Clave"
          :required="true"
          :maxlength="50"
          :disabled="isEditing"
          helpText="Código único del socio de negocio"
        />
      </div>
      <div class="col-md-6">
        <!-- Campo EmpresaId oculto - se captura automáticamente -->
        <input type="hidden" v-model="formData.EmpresaId" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <FormField
          id="ClaveErp"
          label="Clave ERP"
          type="text"
          v-model="formData.ClaveErp"
          :maxlength="50"
          helpText="Clave en el sistema ERP"
        />
      </div>
      <div class="col-md-6">
        <FormField
          id="TipoSocio"
          label="Tipo Socio"
          type="text"
          v-model="formData.TipoSocio"
          :maxlength="50"
          helpText="Tipo de socio de negocio"
        />
      </div>
    </div>

    <!-- Información Comercial -->
    <div class="row">
      <div class="col-md-6">
        <FormField
          id="NombreComercial"
          label="Nombre Comercial"
          type="text"
          v-model="formData.NombreComercial"
          :required="true"
          :maxlength="200"
          helpText="Nombre comercial del socio"
        />
      </div>
      <div class="col-md-6">
        <FormField
          id="RazonSocial"
          label="Razón Social"
          type="text"
          v-model="formData.RazonSocial"
          :required="true"
          :maxlength="200"
          helpText="Razón social del socio"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <FormField
          id="RFC"
          label="RFC"
          type="text"
          v-model="formData.RFC"
          :maxlength="13"
          helpText="Registro Federal de Contribuyentes"
        />
      </div>
      <div class="col-md-6">
        <FormField
          id="CURP"
          label="CURP"
          type="text"
          v-model="formData.CURP"
          :maxlength="18"
          helpText="Clave Única de Registro de Población"
        />
      </div>
    </div>

    <!-- Dirección -->
    <div class="row">
      <div class="col-md-8">
        <FormField
          id="Calle"
          label="Calle"
          type="text"
          v-model="formData.Calle"
          :maxlength="200"
          helpText="Nombre de la calle"
        />
      </div>
      <div class="col-md-2">
        <FormField
          id="NumExt"
          label="Núm. Ext."
          type="text"
          v-model="formData.NumExt"
          :maxlength="10"
          helpText="Número exterior"
        />
      </div>
      <div class="col-md-2">
        <FormField
          id="NumInt"
          label="Núm. Int."
          type="text"
          v-model="formData.NumInt"
          :maxlength="10"
          helpText="Número interior"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <FormField
          id="Colonia"
          label="Colonia"
          type="text"
          v-model="formData.Colonia"
          :maxlength="100"
          helpText="Colonia o fraccionamiento"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="Localidad"
          label="Localidad"
          type="text"
          v-model="formData.Localidad"
          :maxlength="100"
          helpText="Localidad"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="Municipio"
          label="Municipio"
          type="text"
          v-model="formData.Municipio"
          :maxlength="100"
          helpText="Municipio o delegación"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <FormField
          id="Estado"
          label="Estado"
          type="text"
          v-model="formData.Estado"
          :maxlength="50"
          helpText="Estado o entidad federativa"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="Pais"
          label="País"
          type="text"
          v-model="formData.Pais"
          :maxlength="50"
          helpText="País"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="CP"
          label="Código Postal"
          type="text"
          v-model="formData.CP"
          :maxlength="10"
          helpText="Código postal"
        />
      </div>
    </div>

    <!-- Contacto -->
    <div class="row">
      <div class="col-md-6">
        <FormField
          id="Telefono1"
          label="Teléfono 1"
          type="text"
          v-model="formData.Telefono1"
          :maxlength="20"
          helpText="Teléfono principal"
        />
      </div>
      <div class="col-md-6">
        <FormField
          id="Telefono2"
          label="Teléfono 2"
          type="text"
          v-model="formData.Telefono2"
          :maxlength="20"
          helpText="Teléfono secundario"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <FormField
          id="Email"
          label="Email"
          type="email"
          v-model="formData.Email"
          :maxlength="100"
          helpText="Correo electrónico"
        />
      </div>
    </div>

    <!-- Contacto de la Empresa -->
    <div class="row">
      <div class="col-md-6">
        <FormField
          id="ContactoNombre1"
          label="Contacto Nombre"
          type="text"
          v-model="formData.ContactoNombre1"
          :maxlength="100"
          helpText="Nombre del contacto principal"
        />
      </div>
      <div class="col-md-6">
        <FormField
          id="ContactoPuesto1"
          label="Contacto Puesto"
          type="text"
          v-model="formData.ContactoPuesto1"
          :maxlength="100"
          helpText="Puesto del contacto"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <FormField
          id="ContactoTelefono1"
          label="Contacto Teléfono"
          type="text"
          v-model="formData.ContactoTelefono1"
          :maxlength="20"
          helpText="Teléfono del contacto"
        />
      </div>
      <div class="col-md-6">
        <FormField
          id="ContactoEmail1"
          label="Contacto Email"
          type="email"
          v-model="formData.ContactoEmail1"
          :maxlength="100"
          helpText="Email del contacto"
        />
      </div>
    </div>

    <!-- Configuración Financiera -->
    <div class="row">
      <div class="col-md-4">
        <FormField
          id="MonedaDefault"
          label="Moneda Default"
          type="text"
          v-model="formData.MonedaDefault"
          :maxlength="10"
          helpText="Moneda por defecto"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="MetodoPagoDefault"
          label="Método Pago Default"
          type="text"
          v-model="formData.MetodoPagoDefault"
          :maxlength="50"
          helpText="Método de pago por defecto"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="FormaPagoDefault"
          label="Forma Pago Default"
          type="text"
          v-model="formData.FormaPagoDefault"
          :maxlength="50"
          helpText="Forma de pago por defecto"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <FormField
          id="UsoCFDIDefault"
          label="Uso CFDI Default"
          type="text"
          v-model="formData.UsoCFDIDefault"
          :maxlength="50"
          helpText="Uso de CFDI por defecto"
        />
      </div>
      <div class="col-md-6">
        <FormField
          id="RegimenFiscal"
          label="Régimen Fiscal"
          type="text"
          v-model="formData.RegimenFiscal"
          :maxlength="50"
          helpText="Régimen fiscal"
        />
      </div>
    </div>

    <!-- Crédito -->
    <div class="row">
      <div class="col-md-4">
        <FormField
          id="DiasCredito"
          label="Días Crédito"
          type="number"
          v-model="formData.DiasCredito"
          :min="0"
          helpText="Días de crédito otorgados"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="LimiteCredito"
          label="Límite Crédito"
          type="number"
          v-model="formData.LimiteCredito"
          :min="0"
          step="0.01"
          helpText="Límite de crédito"
        />
      </div>
      <div class="col-md-4">
        <FormField
          id="SaldoActual"
          label="Saldo Actual"
          type="number"
          v-model="formData.SaldoActual"
          step="0.01"
          helpText="Saldo actual del crédito"
        />
      </div>
    </div>

    <!-- Estado y Notas -->
    <div class="row">
      <div class="col-md-6">
        <FormField
          id="EsActivo"
          label="Estado"
          type="checkbox"
          v-model="formData.EsActivo"
          checkboxLabel="Socio de negocio activo"
          helpText="Indica si el socio de negocio está activo en el sistema"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <FormField
          id="Notas"
          label="Notas"
          type="textarea"
          v-model="formData.Notas"
          :maxlength="500"
          helpText="Notas adicionales"
        />
      </div>
    </div>
    
    <div class="d-flex gap-2 mt-4">
      <button type="button" class="btn btn-primary" :disabled="loading" @click="submitForm">
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="bi bi-save me-1"></i>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';
import empresaMixin from '@/shared/mixins/empresaMixin';

export default {
  name: 'CatSocioNegocioForm',
  components: {
    FormField
  },
  mixins: [empresaMixin],
  props: {
    socioNegocio: {
      type: Object,
      default: () => ({
        Clave: '',
        EmpresaId: 1,
        ClaveErp: '',
        TipoSocio: '',
        NombreComercial: '',
        RazonSocial: '',
        RFC: '',
        CURP: '',
        Calle: '',
        NumExt: '',
        NumInt: '',
        Colonia: '',
        Localidad: '',
        Municipio: '',
        Estado: '',
        Pais: '',
        CP: '',
        Telefono1: '',
        Telefono2: '',
        Email: '',
        ContactoNombre1: '',
        ContactoPuesto1: '',
        ContactoTelefono1: '',
        ContactoEmail1: '',
        MonedaDefault: '',
        MetodoPagoDefault: '',
        FormaPagoDefault: '',
        UsoCFDIDefault: '',
        RegimenFiscal: '',
        DiasCredito: 0,
        LimiteCredito: 0,
        SaldoActual: 0,
        EsActivo: true,
        Notas: ''
      })
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: { ...this.socioNegocio }
    };
  },
  watch: {
    socioNegocio: {
      handler(newValue) {
        this.formData = { ...newValue };
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    submitForm() {
      // Asegurar que la empresa esté capturada antes de enviar
      this.ensureEmpresaCaptured();
      
      // Preparar datos para envío
      const dataToSubmit = { ...this.formData };
      
      this.$emit('submit', dataToSubmit);
    }
  }
};
</script>

<style scoped>
/* Estilos específicos del formulario si son necesarios */
</style>